import * as React from "react"
import { Box, Card, Typography, Skeleton } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { statsData, isLoadingStats } from "./@signals"


function StatCard({ icon, label, value, subValue, color = 'primary.main', bgColor = '#f0f9ff' }) {
    return (
        <Card
            variant="outlined"
            sx={{
                p: 2,
                flex: 1,
                minWidth: 180,
                backgroundColor: bgColor,
                borderColor: 'transparent'
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Box sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'white',
                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                }}>
                    <IconSeeker icon={icon} sx={{ color, fontSize: 20 }} />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ fontWeight: 700, color, lineHeight: 1.2 }}>
                        {value}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        {label}
                    </Typography>
                    {subValue && (
                        <Typography variant="caption" color="text.disabled" display="block" sx={{ fontSize: '0.65rem' }}>
                            {subValue}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Card>
    )
}

function StatCardSkeleton() {
    return (
        <Card variant="outlined" sx={{ p: 2, flex: 1, minWidth: 180 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Skeleton variant="rounded" width={40} height={40} />
                <Box>
                    <Skeleton variant="text" width={60} height={28} />
                    <Skeleton variant="text" width={80} height={16} />
                </Box>
            </Box>
        </Card>
    )
}

export default function StatsCards() {
    const stats = statsData.value
    const isLoading = isLoadingStats.value

    if (!stats && !isLoading) return null

    if (isLoading) {
        return (
            <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <StatCardSkeleton />
                <StatCardSkeleton />
                <StatCardSkeleton />
            </Box>
        )
    }

    const matchColor = stats.match_percentage >= 80 ? '#10b981' :
                       stats.match_percentage >= 50 ? '#f59e0b' : '#ef4444'

    return (
        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
            <StatCard
                icon="chart-pie"
                label="Match Rate"
                value={`${stats.match_percentage}%`}
                subValue={`${stats.matched} of ${stats.total}`}
                color={matchColor}
                bgColor={stats.match_percentage >= 80 ? '#ecfdf5' : stats.match_percentage >= 50 ? '#fffbeb' : '#fef2f2'}
            />
            <StatCard
                icon="link"
                label="Matched"
                value={stats.matched?.toLocaleString()}
                color="#10b981"
                bgColor="#ecfdf5"
            />
            <StatCard
                icon="link-slash"
                label="Unmatched"
                value={stats.unmatched?.toLocaleString()}
                color="#ef4444"
                bgColor="#fef2f2"
            />
        </Box>
    )
}
